// Both CSRF endpoints can answer 200 with an empty body.
export const readCsrfToken = (body: string | undefined): string | undefined => {
  if (!body) {
    return undefined;
  }
  try {
    const parsed: unknown = JSON.parse(body);
    if (
      typeof parsed === 'object' &&
      parsed !== null &&
      'csrfToken' in parsed &&
      typeof parsed.csrfToken === 'string'
    ) {
      return parsed.csrfToken;
    }
  } catch {
    return undefined;
  }
  return undefined;
};
